import React, { ReactElement } from "react";
import dynamic from "next/dynamic";
import { LoadingSkeleton } from "@kunduz/ui";

const MobileLazyLoadedLogo = dynamic<any>(
  () => {
    return import("./mobileLogo").then((module) => module.MobileLogo);
  },
  {
    ssr: false,
    loading: () => (
      <div style={{ display: "flex", gap: 12 }}>
        <LoadingSkeleton style={{ width: 120, height: 34 }} />
      </div>
    ),
  },
);

export const MobileLogoLoader = (props: {
  lang: "tr" | "en";
}): ReactElement => {
  return <MobileLazyLoadedLogo {...props} />;
};
